export const $ = jQuery;
export const w = $(window);


// WEBPACK FOOTER //
// ./es6/constants.js